export default __webpack_public_path__ + "static/media/at-symbol.aca926fd.svg";